/// <amd-module name="SuiteCommerce.GiftCertificate.GiftCertificateMessage.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GiftCertificate.GiftCertificateMessage.View", ["require", "exports", "Backbone", "sc_gift_certificate_message.tpl"], function (require, exports, Backbone_1, MessageViewTemplate) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.GiftCertificateMessageView = void 0;
    var GiftCertificateMessageView = /** @class */ (function (_super) {
        __extends(GiftCertificateMessageView, _super);
        function GiftCertificateMessageView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = MessageViewTemplate;
            _this.events = {
                'click [data-action="ext-message-close-message"]': 'closeMessage',
            };
            return _this;
        }
        ;
        GiftCertificateMessageView.prototype.closeMessage = function () {
            this.remove();
        };
        ;
        GiftCertificateMessageView.prototype.getContext = function () {
            return {
                showMessage: this.model.message.length > 0,
                message: this.model.message,
                isClosable: this.model.closable,
                type: this.model.type ? this.model.type : '',
            };
        };
        return GiftCertificateMessageView;
    }(Backbone_1.View));
    exports.GiftCertificateMessageView = GiftCertificateMessageView;
});
